// src/lib/supabase.ts
import {
  createClient,
  type SupabaseClient,
  type Session,
  type AuthChangeEvent,
} from "@supabase/supabase-js";

// ---- ENV (CRA primero, luego Vite) ----
const url =
  (process.env.REACT_APP_SUPABASE_URL as string) ||
  (process.env.VITE_SUPABASE_URL as string) ||
  "";

const anon =
  (process.env.REACT_APP_SUPABASE_ANON_KEY as string) ||
  (process.env.VITE_SUPABASE_ANON_KEY as string) ||
  "";

if (!url || !anon) {
  throw new Error(
    "Faltan variables de entorno: REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY (o VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY)."
  );
}

// URL de Functions (local en dev si la defines, o la del proyecto)
const functionsUrl =
  (process.env.REACT_APP_SUPABASE_FUNCTIONS_URL as string) ||
  (process.env.VITE_SUPABASE_FUNCTIONS_URL as string) ||
  `${url.replace(/\/$/, "")}/functions/v1`;

export const supabase: SupabaseClient = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  functions: { url: functionsUrl },
});

// ===== Helpers comunes de auth (para no repetir lógica) =====
export async function getCurrentSession(): Promise<Session | null> {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    console.warn("[supabase] getSession error:", error.message);
    return null;
  }
  return data.session ?? null;
}

export function onAuth(cb: (event: AuthChangeEvent, session: Session | null) => void) {
  const { data: sub } = supabase.auth.onAuthStateChange((event, session) => cb(event, session));
  return () => sub.subscription.unsubscribe();
}
